import React from 'react';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import ContentCourseFailureAttemptRateGaugeContainer from './course/ContentCourseFailureAttemptRateGaugeContainer';
import ContentCourseRepeatRateGaugeContainer from './course/ContentCourseRepeatRateGaugeContainer';
import ContentCourseSpeechRateGaugeContainer from './course/ContentCourseSpeechRateGaugeContainer';
import ContentCourseErrorRateGaugeContainer from './course/ContentCourseErrorRateGaugeContainer';

const ContentCourseChartScene = () => (
  <div>
    <Row>
      <Column size={3}>
        <ContentCourseFailureAttemptRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentCourseRepeatRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentCourseSpeechRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentCourseErrorRateGaugeContainer />
      </Column>
    </Row>
  </div>
);

export default ContentCourseChartScene;
